import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import './animated-gift-box.css';
import openBaseImg from '../../assets/gift-pack/open-base.png';
import lidImg from '../../assets/gift-pack/lid.png';
import couponImg from '../../assets/gift-pack/coupon.png';

const CONFETTI = [
  { color: '#17b8a6', dx: -95, dy: -70, rot: 140, delay: 0.6 },
  { color: '#ff3d81', dx: 85, dy: -95, rot: -120, delay: 0.66 },
  { color: '#ffb238', dx: -55, dy: -115, rot: 200, delay: 0.72 },
  { color: '#6c4ce8', dx: 100, dy: -35, rot: -80, delay: 0.6 },
  { color: '#17b8a6', dx: -110, dy: -15, rot: 60, delay: 0.78 },
  { color: '#ffb238', dx: 65, dy: -120, rot: -160, delay: 0.68 },
  { color: '#6c4ce8', dx: -30, dy: -130, rot: 40, delay: 0.74 },
  { color: '#ff3d81', dx: 40, dy: -125, rot: -60, delay: 0.62 },
];

export default function AnimatedGiftBox() {
  const [opened, setOpened] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setOpened(true), 600);
    return () => clearTimeout(t);
  }, []);

  return (
    <motion.div
      className="agb-stage"
      initial={{ opacity: 0, scale: 0.7 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ type: 'spring', stiffness: 140, damping: 13 }}
    >
      <motion.div
        className="agb-glow"
        animate={opened ? { opacity: [0, 0.9, 0.45], scale: [0.6, 1.4, 1.15] } : { opacity: 0, scale: 0.6 }}
        transition={{ duration: 0.9, delay: 0.35, ease: 'easeOut' }}
      />

      <img src={openBaseImg} alt="" className="agb-base" />

      <motion.img
        src={lidImg}
        alt=""
        className="agb-lid"
        animate={
          opened
            ? { rotate: -20, x: 26, y: -57, opacity: 0, scale: 1.09 }
            : { rotate: 0, x: 0, y: 15, opacity: 1, scale: 1.28 }
        }
        transition={{ duration: 0.55, delay: 0.15, ease: 'easeIn' }}
      />

      <div className="agb-coupon-anchor">
        <motion.img
          src={couponImg}
          alt="Your deal"
          className="agb-coupon"
          animate={
            opened
              ? { opacity: 1, scale: 1, rotate: -7, y: -42 }
              : { opacity: 0, scale: 0.5, rotate: -14, y: 50 }
          }
          transition={{ duration: 0.7, delay: 0.55, ease: [0.16, 1, 0.3, 1] }}
        />
      </div>

      {opened &&
        CONFETTI.map((c, i) => (
          <motion.span
            key={i}
            className="agb-confetti"
            style={{ background: c.color }}
            initial={{ opacity: 0, x: 0, y: 0, rotate: 0, scale: 0.6 }}
            animate={{ opacity: [0, 1, 1, 0], x: c.dx, y: c.dy, rotate: c.rot, scale: 1 }}
            transition={{ duration: 1.1, delay: c.delay, ease: 'easeOut' }}
          />
        ))}
    </motion.div>
  );
}
